import React, { useEffect, useRef, useState } from 'react';
import loadable from '@loadable/component';
import css from './ListingVideo.module.css';

// Use loadable to import react-player without SSR
const ReactPlayer = loadable(() => import('react-player'), {
  ssr: false,
});

const ListingVideo = ({ currentListing, className = '' }) => {
  // Track if component is mounted in the browser
  const [isBrowser, setIsBrowser] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const videoPlayerRef = useRef(null);

  // Set isBrowser flag once on mount (client-only)
  useEffect(() => {
    setIsBrowser(true);
  }, []);

  // Handle window resize to determine mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 576);
    window.addEventListener('resize', handleResize);
    // Run once on mount
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Extract video link safely from props
  const videoLink = currentListing?.attributes?.publicData?.youtubeLink || null;

  const triggerDataElbAction = () => {
    if (videoPlayerRef.current) {
      const event = new MouseEvent('click', { bubbles: true });
      videoPlayerRef.current.dispatchEvent(event);
    }
  };

  // Prevent rendering on the server
  if (!isBrowser) return null;

  return videoLink ? (
    <div className={`${css.videoSectionWrapper} ${className}`.trim()}>
      <div
        className={css.videoPlayer}
        data-elbaction="click:click ytvideostart"
        ref={videoPlayerRef}
      >
        <ReactPlayer
          controls
          width="100%"
          height={isMobile ? '202px' : '300px'}
          url={videoLink}
          onPlay={triggerDataElbAction}
        />
      </div>
    </div>
  ) : null;
};

export default ListingVideo;
